"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const responseError = require("./common/responseError");
const app_1 = require("./app");
const identifiers_1 = require("./identifiers");
const filterUndefinedKeys_1 = require("./common/filterUndefinedKeys");
const filterNullKeys_1 = require("./common/filterNullKeys");
const getUsers_1 = require("./getUsers");
function updateUser(userId, updateUserInfoObj) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const usersRef = app_1.app.firestore.collection('users').doc(userId);
            const userDocResponse = yield getUsers_1.default({
                userId
            });
            const userDoc = userDocResponse[0];
            if (!userDoc) {
                throw new Error('User with given id does not exist in the database');
            }
            else {
                const { providerIds, permissions, name, password, googleAuthRefreshToken } = updateUserInfoObj;
                const sourceObj = {
                    providerIds,
                    name,
                    password,
                    googleAuthRefreshToken
                };
                // filter undefined or null values
                const filteredUpdateUserInfoObj = filterNullKeys_1.default(filterUndefinedKeys_1.default(sourceObj));
                const isFilteredObjExists = Object.keys(filteredUpdateUserInfoObj).length;
                if (isFilteredObjExists) {
                    yield usersRef.set(filteredUpdateUserInfoObj, {
                        merge: true
                    });
                }
                // check for password
                if (password) {
                    // call endpoint updateUserPassword
                    const body = {
                        userId,
                        password
                    };
                    const url = `${identifiers_1.Types.BACKEND_URL}/updateUserPassword`;
                    try {
                        const urlResponse = yield fetch(url, {
                            method: 'POST',
                            body: JSON.stringify(body),
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                        const response = yield urlResponse.json();
                        console.log(response);
                    }
                    catch (e) {
                        console.log('error updating password: ', e.message);
                    }
                }
                // update permisssions
                if (permissions) {
                    const batch = app_1.app.firestore.batch();
                    // update each element of permissions array using arrayUnion
                    permissions.forEach(permission => {
                        batch.update(usersRef, { permissions: app_1.app.firestoreFieldValue.arrayUnion(permission) });
                    });
                    yield batch.commit();
                }
                const userDocResponse = yield getUsers_1.default({
                    userId
                });
                const updatedUserDoc = userDocResponse[0];
                return updatedUserDoc;
            }
        }
        catch (e) {
            console.log('Error updating user: ', e.message);
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, 'Error while updating user', e.message);
        }
    });
}
exports.default = updateUser;
//# sourceMappingURL=updateUser.js.map